.image {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  object-fit: cover;
  box-sizing: border-box;
  border: 1px var(--bg-color-dark-black) solid;
  border-radius: 0.8rem;
}
